import React from "react";
import {Keyboard} from "lucide-react";


interface OpenKeyBoardButtonProps extends React.HTMLAttributes<HTMLDivElement>{
    keyboardVisible:boolean,
    keyboardFocused: boolean,
    blurHiddenInput: () => void,
    focusHiddenInput: () => void

}


export const OpenKeyBoardButton = ({keyboardVisible,keyboardFocused,blurHiddenInput,focusHiddenInput,...props}:OpenKeyBoardButtonProps) => {
    return(
    <div className={`fixed bottom-28 right-3 z-50 transition-all duration-300 ease-in-out
                    ${keyboardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        <button
            type="button"
            onClick={keyboardFocused ? blurHiddenInput : focusHiddenInput}
            className={`flex items-center gap-2 backdrop-blur-md text-white rounded-full
                        px-4 py-2.5 shadow-lg shadow-black/30 border transition-colors duration-200
                        ${keyboardFocused
                            ? 'bg-orange-600/80 border-orange-400/40'
                            : 'bg-black/70 border-white/10'}`}
        >
            <Keyboard className={`w-4 h-4 ${keyboardFocused ? 'text-white' : 'text-orange-300 animate-pulse'}`} />
            <span className="text-xs font-medium">
                {keyboardFocused ? 'Escribiendo…' : 'Abrir teclado'}
            </span>
        </button>
    </div>
    );}